import React from 'react';

function ArrowUp(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M19.5458 10.9418C19.7897 11.186 20.1854 11.1863 20.4297 10.9424C20.6739 10.6985 20.6742 10.3027 20.4303 10.0585L12.7951 2.41258C12.3558 1.97268 11.643 1.97247 11.2034 2.41211L3.55892 10.0582C3.31486 10.3023 3.31491 10.6981 3.55901 10.9421C3.80311 11.1862 4.19884 11.1861 4.44289 10.942L11.3695 4.01394L11.3695 21.3909C11.3695 21.736 11.6493 22.0159 11.9945 22.0159C12.3397 22.0159 12.6195 21.736 12.6195 21.3909L12.6195 4.00579L19.5458 10.9418Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default ArrowUp;
